export default __webpack_public_path__ + "static/media/aiGallery.dc1a0eda.png";